import { Client, Equipment, Maintenance, Site, User } from "./index"
import maintenanceApi from "./api"
import environment from "@/config"
import storage from "@/storage"
import { ISiteStorage } from "@/storage/model"
import { Observable } from "rxjs"
import { startWith } from 'rxjs/operators';

export abstract class BaseMaintenanceBloc {
    module = 'maintenance';
    api = maintenanceApi;
    base_url = environment.API_URL + '/' + module;

    async getMaintenances(): Promise<[Maintenance]> {
        let response = await this.api.all()
        return response.data.data;
    }

    async getMaintenance(id: any): Promise<Maintenance> {
        const params = {
            with: "customField"
        }
        let response = await this.api.first(id, params)
        return response.data;
    }

    async createMaintenance(maintenance: Maintenance): Promise<Maintenance> {
        let response = await this.api.create(maintenance)
        return response.data;
    }

    async storeRelation(maintenance: Maintenance): Promise<Maintenance> {
        let response = await this.api.storeRelation(maintenance)
        return response.data;
    }

    async serialNumber(): Promise<Maintenance> {
        let response = await this.api.serialNumber()
        return response.data;
    }

    async updateRelation(maintenance: Maintenance): Promise<Maintenance> {
        let response = await this.api.updateRelation(maintenance.id, maintenance)
        return response.data;
    }

    async downloadFile(fileName: string, id: any): Promise<void> {
        await this.api.download(fileName, id);
    }

    async deleteRelation(id: any): Promise<void> {
        let response = await this.api.deleteRelation(id)
        return response.data;
    }

    async updateMaintenance(maintenance: Maintenance): Promise<Maintenance> {
        let response = await this.api.edit(maintenance.id, maintenance)
        return response.data;
    }

    // FIXME: not working
    async destroyMaintenance(id: any): Promise<void> {
        let response = await this.api.destroy(id)
        return response.data;
    }

    searchParams(maintenance: Maintenance): string {
        const params = {
            search: {
                advanced: maintenance
            }
        }
        return this.api.getUrl(`/${this.module}`, params);
    }

    async getClient(id: any): Promise<Client> {
        let response = await this.api.clientFirst(id)
        return response.data;
    }

    async getSite(id: any): Promise<Site> {
        let response = await this.api.siteFirst(id)
        return response.data;
    }

    async getEquipment(id: any): Promise<Equipment> {
        let response = await this.api.equipmentFirst(id)
        return response.data;
    }

    async getEquipmentBySite(site_id: any): Promise<Equipment[]> {
        let response = await this.api.getEquipmentBySite(site_id)
        return response.data;
    }

    async getUser(id: any): Promise<User> {
        let response = await this.api.userFirst(id)
        return response.data;
    }

    async getSiteStorage(): Promise<Observable<ISiteStorage>> {
        const siteStorage: ISiteStorage = await storage.get<ISiteStorage>(storage.SITE);
        return storage.observable<ISiteStorage>(storage.SITE).pipe(startWith(siteStorage));
    }

    getMaintenanceUrlBySite(): string {
        const site = storage.getSync<ISiteStorage>(storage.SITE);
        const params = {
            search: {
                advanced: {
                    site_id: site.id
                }
            }
        }
        return this.api.getUrl(`/${this.module}`, params);
    }

    async getClientOptions(): Promise<any[]> {
        const params = {
            "no-paginate": true
        }
        return await this.api.getOptions('/client', params);
    }

    async getSiteOptions(): Promise<any[]> {
        const params = {
            "no-paginate": true
        }
        return await this.api.getOptions('/site', params);
    }

    async getUserOptions(): Promise<any[]> {
        const params = {
            "no-paginate": true
        }
        return await this.api.getOptions('/user', params);
    }

    async getEquipmentOptionsBySite(id: any): Promise<any[]> {
        const params = {
            "no-paginate": true,
            search: {
                advanced: {
                    site: id
                }
            }
        }
        return await this.api.getOptions(`/equipment`, params, 'id', ['tag_number']);
    }

    async getJobOptions(): Promise<any[]> {
        const params = {
            "no-paginate": true,
            search: {
                advanced: {
                    name: 'Type of Job'
                }
            }
        }
        return await this.api.getOptions('/reference', params, 'text');
    }
}

